/**
 * These are helper functions to prevent the i18n from translating strings.
 * We usually use these to indicate that a string shouldn't be translated yet
 * (or at all).
 */
import type * as React from "react";

// A basic tagged template that doesn't translate.
export const doNotTranslate = (
    strings: TemplateStringsArray,
    ...values: any[]
) => {
    return strings
        .map(
            (string, i) =>
                string + (i < values.length ? String(values[i]) : ""),
        )
        .join("");
};

// A basic tagged template that doesn't translate.
export const doNotTranslateYet = doNotTranslate;

export const NoTrans = ({
    children,
}: {
    children: React.ReactNode;
    context?: string;
}) => children;

export const NoTransYet = ({
    children,
}: {
    children: React.ReactNode;
    context?: string;
}) => children;
